export default "__VITE_ASSET__187af1db__"